import { action } from 'typesafe-actions';
import { DataHoraordemDeCargaTypes, IDataHoraordemDeCarga } from './types';

export const loadRequest = (
  dtAgendamento: string,
  codHorario: number,
  codPlataforma: number,
  dhAgendamento: string
) =>
  action(DataHoraordemDeCargaTypes.LOAD_REQUEST, {
    dtAgendamento,
    codHorario,
    codPlataforma,
    dhAgendamento,
  });
export const loadSuccess = (data: IDataHoraordemDeCarga) =>
  action(DataHoraordemDeCargaTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(DataHoraordemDeCargaTypes.LOAD_FAILURE, {});
